module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"audit_preparation":"Audit Vorbereiten","audit_execution":"Audit Durchführen","audit_wrapup":"Audit Nachbereiten","audit_reporting":"Audit Reporting","audit_actionlist":"Maßnahmen umsetzen"},"en":{"audit_preparation":"Prepare","audit_execution":"Execute","audit_wrapup":"Wrapping Up","audit_reporting":"Report","audit_actionlist":"Execution"}}')
  delete Component.options._Ctor
}
